// extracted by mini-css-extract-plugin
export var required = "_e0-0";